import { Text } from '@bygghemmait/components';
import cn from 'classnames';
import { getCreative, getSlot } from 'components/Ad';
import { Button } from 'components/Button';
import { Cell, Grid } from 'components/Grid';
import { Section, SectionTitle } from 'components/Section';
import { isMobile as isMobileSelector } from 'components/Shared/responsive';
import { PpNewStartPage } from 'models/PpNewStartPage';
import { useDispatch, useSelector } from 'react-redux';
import { GtmSelectPromotion } from 'store/googleTagManager/actions';
import { rm } from 'utils';
import styles from './styles.scss';

const adGtmPromotion = {
  promotion_id: '12345_1_new_start_page_top_ad',
  promotion_name: 'new_start_page_top_ad',
  creative_name: getCreative(27),
  creative_slot: getSlot(1)
};

export const NewStartPage = ({ ad, contentBoxes, popularCategory }: PpNewStartPage) => {
  const isMobile = useSelector(isMobileSelector);
  const gutterSize = isMobile ? 'large' : 'medium';
  const dispatch = useDispatch();

  const handleAdClick = () => {
    dispatch(GtmSelectPromotion(adGtmPromotion));
  };

  return (
    <>
      <Section className={styles.section}>
        <a href={ad.url} className={styles.adWrapper} onClick={handleAdClick}>
          <img src={ad.imageUrl} className={styles.adImage} alt={ad.title} />
          <div className={styles.adText}>
            <Text
              $variant={isMobile ? 'h3' : 'h1'}
              $family="primary"
              className={cn(styles.upperCase, styles.textShadow)}
            >
              {ad.title}
            </Text>
            <Text
              $variant={isMobile ? 'h4' : 'h3'}
              $family="primary"
              $weight="regular"
              className={styles.textShadow}
            >
              {ad.description}
            </Text>
          </div>
          <div className={styles.adButton}>
            <Button size="medium">
              <Text className={styles.upperCase}>{ad.buttonText}</Text>
            </Button>
          </div>
        </a>
      </Section>
      <Section>
        {contentBoxes.map((item, index) => (
          <a
            href={item.url}
            key={index}
            className={cn(styles.box, {
              [styles.reverse]: index === 1
            })}
          >
            <div className={styles.boxImageWrapper}>
              <img src={item.imageUrl} alt={item.buttonText} />
              <div className={styles.boxButton}>
                <Button size="small">
                  <Text className={styles.upperCase}>{item.buttonText}</Text>
                </Button>
              </div>
            </div>
            <Text
              $variant={isMobile ? 'h5' : 'h4'}
              className={cn(styles.boxDescription, { [styles.reverse]: index === 1 })}
              $family="primary"
            >
              {item.description}
            </Text>
          </a>
        ))}
      </Section>
      <Section className={styles.section}>
        <div className={styles.sectionWrapper}>
          <SectionTitle title={rm('startpage_popular_categories')} />
          <Grid
            huge="4"
            desktop="4"
            large="4"
            tablet="3"
            phone="2"
            gutters={gutterSize}
            className={styles.cardWrapper}
          >
            {popularCategory.map((category, index) => (
              <Cell key={index}>
                <a href={category.url} className={styles.card}>
                  <img src={category.imageUrl} className={styles.cardImage} alt={category.name} />
                  <div className={styles.cardButton}>
                    <Button size="small">
                      <Text className={styles.upperCase}>{category.name}</Text>
                    </Button>
                  </div>
                </a>
              </Cell>
            ))}
          </Grid>
        </div>
      </Section>
    </>
  );
};
